export default class Validator {
  static validate() {
    throw new Error('validate method not implemented');
  }
}
